import React, { useEffect, useState } from "react";
import {
  Box
} from "@chakra-ui/react";
import TransactionTable from "./components/TransactionTable";
import { useHistory } from "react-router-dom";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { formatYMD } from "views/helpers/date";

export default function Transactions() {
  const [trxns, setTrxns] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [reportDate, setReportDate] = useState(new Date().toLocaleDateString("en-GB", { timeZone: 'Africa/Lagos' }));
  const [filter, setFilterState] = useState(false);

  let navigate = useHistory();

  useEffect(() => {
    const clientInfo = sessionStorage.getItem('clientInfo');
    const key = sessionStorage.getItem('token');
    if (clientInfo) {
      const { agentId, role } = JSON.parse(clientInfo);
      if (role === 'Admin') {
        navigate.push('/auth');
      }

      const apiHeader = {
        headers: {
          "authorization": `Bearer ${key}`
        }
      }

      const fetchData = () => getTrxns(agentId, reportDate, apiHeader);
      fetchData();

      const intervalData = setInterval(fetchData, 300000);

      return () => clearInterval(intervalData);
    }
    else
      navigate.push('/auth');
  }, [reportDate]);

  const getTrxns = async (agentId, date, header) => {
    setIsloading(true);

    const params = {
      agentId: agentId,
      transDate: formatYMD(date)
    };

    try {
      const response = await axios.post(getAPIEndpoint('trxns'), params, header);
      if (response) {
        const { status, data } = response.data;
        if (status === 'success' && data)
          setTrxns(data);
        else
          setTrxns([]);
      }
    } catch (error) {
      await logger({ task: "Get transactions", error: error.toString() });
    }

    setIsloading(false);
  }

  const props = {
    isLoading,
    reportDate,
    filter,
    setReportDate,
    setFilterState,
    trxns
  }

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <TransactionTable {...props} />
    </Box>
  );
}
